import { SubjectModel } from "./subject-model";

export interface ISubject {
  serialNo: string;
  subjectModelId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  schemaVersion: string;
}

export class Subject implements ISubject {
  id: string;
  name: string;
  shortName: string;
  description: string;
  displayName?: string;
  serialNo: string;
  subjectModelId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  isValid: boolean;
  schemaVersion: string;
  createdBy: string;
  createDate: string;
  lastUpdatedBy: string;
  lastUpdateDate: string;
  hasInspections?: boolean;
  version?: number;
  isOfflineData: boolean;

  subjectModel: SubjectModel;
}

export class SubjectNew implements ISubject {
  serialNo: string;
  subjectModelId: string;
  schemaVersion: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
}

export class SubjectUpdate implements ISubject {
  id: string;
  serialNo: string;
  subjectModelId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  isValid: boolean;
  schemaVersion: string;
}

export class SubjectClone implements ISubject {
  id: string;
  serialNo: string;
  subjectModelId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  isValid: boolean;
  schemaVersion: string;
}

export class SubjectDetail extends Subject {
  isDeleted: boolean;
}

export class SubjectAttributes {
  subjectId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;
  version: number;
  isNewestVersion: boolean;
}
